import { useState, useEffect } from "react";
import { getCountAll } from "../../services/statistikaDokumenta.service";
import "./UkupnaPosjecenostDokumenta.css";

const UkupnaPosjecenostDokumenta = ({ className }) => {
  const [ukupnoPosjeta, setUkupnoPosjeta] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const ucitajStatistiku = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await getCountAll();
        setUkupnoPosjeta(response.data);
      } catch (error) {
        setError("Došlo je do greške pri učitavanju podataka");
      } finally {
        setLoading(false);
      }
    };

    ucitajStatistiku();
  }, []);

  if (loading) {
    return <div>Učitavanje podataka...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <div className="ukupnaposjecenostdokumenta-div">

          <h2 className="ukupnaposjecenostdokumenta-h2">
            Ukupan broj posjeta svih dokumenata:
          </h2>
          <p className="ukupnaposjecenostdokumenta-p">{ukupnoPosjeta}</p>
    </div>
  );
};

export default UkupnaPosjecenostDokumenta;
